
<template>
  <!--小区配置-->
  <x-addEdit
    ref="addEdit"
    class="community-config"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
    <template slot="expire" slot-scope="{formItem}">
      <a-form-item class="expire" :label="formItem.label" v-bind="{labelCol: { span: 8 }, wrapperCol: { span: 11 }}">
        <a-row type="flex">
          <template v-for="(item, index) of formItem.subList">
            <a-col v-if="item.inputType==='inputNumber'" class="a-col" :key="index">
              <a-form-item class="expire-item" :label="item.label">
                <a-input-number v-if="item.label==='业主'" v-decorator="item.props" :min="item.min" :max="item.max" :disabled="item.disabled"/>
                <a-input-number v-else v-decorator="item.props" :min="item.min" :max="item.max"/>
                <span v-if="item.unit" class="ant-form-text">{{item.unit}}</span>
              </a-form-item>
            </a-col>

            <a-col v-if="item.inputType==='checkboxGroup'" class="a-col" :key="index" >
              <a-form-item class="expire-item" :label="item.label">
                <a-checkbox-group @change="foreverChange" v-decorator="item.props" :options="item.options" :style="{width: '100%'}">
                </a-checkbox-group>
              </a-form-item>
            </a-col>
          </template>
        </a-row>
      </a-form-item>
    </template>
  </x-addEdit>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'communityConfig',
  data () {
    let decoratorOptions = {
      communityName: {},
      gateRingPattern: {
        validateTrigger: 'blur',
        rules: [
          { required: true, message: '请输入公共门房号呼叫格式' },
          { min: 6, max: 18, message: this.$store.state.callFormat }
        ]
      },
      // icMode: {
      //   rules: [{ required: true, message: '请选择IC卡模式' }]
      // },
      // isFace: {
      //   valuePropName: 'checked',
      //   initialValue: false,
      //   rules: [{ required: true, message: '请选择人脸识别' }]
      // },
      ownerTime: {
        rules: [
          { required: true, message: '业主期限' },
          // { type: 'integer', message: '请输入整数' },
          { pattern: this.REG.positiveInt, message: '请输入正整数' }
        ]
      },
      isForever: {
        rules: []
      },
      familyTime: {
        rules: [
          {required: true, message: '家属期限'},
          // {type: 'integer', message: '请输入整数'}
          { pattern: this.REG.positiveInt, message: '请输入正整数' }
        ]
      },
      tenantTime: {
        rules: [
          { required: true, message: '租户期限' },
          // {type: 'integer', message: '请输入整数'}
          { pattern: this.REG.positiveInt, message: '请输入正整数' }
        ]
      },
      isPhoneAuth: {
        valuePropName: 'checked',
        initialValue: false,
        rules: [{required: true, message: '请选择电话认证'}]
      },
      isAutoAlloteKey: {
        valuePropName: 'checked',
        initialValue: false,
        rules: [{ required: true, message: '请选择自动分配钥匙' }]
      },
      isOwnerAuth: {
        valuePropName: 'checked',
        initialValue: false,
        rules: [{ required: true, message: '请选择是否授权' }]
      }
    };
    return {
      formList: [
        {
          label: '小区名',
          inputType: 'text',
          options: [],
          placeholder: '',
          props: ['communityName', decoratorOptions.communityName]
        },
        {
          label: '公共门房号呼叫格式',
          inputType: 'input',
          options: [],
          placeholder: '请输入公共门房号呼叫格式',
          help: this.$store.state.callFormat,
          props: ['gateRingPattern', decoratorOptions.gateRingPattern]
        },
        // {
        //   label: 'IC卡模式',
        //   inputType: 'select',
        //   options: [],
        //   placeholder: '请选择IC卡模式',
        //   props: ['icMode', decoratorOptions.icMode]
        // },
        // {
        //   label: '人脸识别',
        //   inputType: 'switch',
        //   options: [],
        //   placeholder: '',
        //   props: ['isFace', decoratorOptions.isFace]
        // },
        {
          slot: 'expire',
          label: '房间认证默认期限',
          inputType: 'input',
          subList: [
            {
              label: '业主',
              inputType: 'inputNumber',
              placeholder: '',
              span: 9,
              unit: '月',
              disabled: false,
              props: ['ownerTime', {
                rules: [{ required: true, message: '业主期限' }]
              }]
            },
            {
              label: '',
              inputType: 'checkboxGroup',
              options: [{ label: '永久', value: 1 }],
              placeholder: '',
              props: ['isForever', decoratorOptions.isForever]
            },
            {
              label: '家属',
              inputType: 'inputNumber',
              options: [],
              unit: '月',
              placeholder: '',
              span: 9,
              props: ['familyTime', decoratorOptions.familyTime]
            },
            {
              label: '租户',
              inputType: 'inputNumber',
              options: [],
              unit: '月',
              placeholder: '',
              span: 9,
              props: ['tenantTime', decoratorOptions.tenantTime]
            }
          ]
        },
        {
          label: '电话认证',
          inputType: 'switch',
          options: [],
          placeholder: '',
          props: ['isPhoneAuth', decoratorOptions.isPhoneAuth]
        },
        {
          label: '自动分配钥匙',
          inputType: 'switch',
          options: [],
          placeholder: '',
          props: ['isAutoAlloteKey', decoratorOptions.isAutoAlloteKey]
        },
        {
          label: '业主授权',
          inputType: 'switch',
          options: [],
          placeholder: '',
          props: ['isOwnerAuth', decoratorOptions.isOwnerAuth]
        }
      ],
      formKey: {
        communityName: '',
        gateRingPattern: '',
        // icMode: '',
        // isFace: '',
        ownerTime: '',
        isForever: '',
        familyTime: '',
        tenantTime: '',
        isPhoneAuth: '',
        isAutoAlloteKey: '',
        isOwnerAuth: ''
      },
      addParam: {
        url: '',
        reqHandle: this.reqHandle,
        resHandle: ''
      },
      editParam: {
        url: '/community/setting/',
        reqHandle: this.reqHandle,
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/community/setting/',
        resHandle: this.detailResHandle
      }
    };
  },
  created () {
    // this.dictionarySelect([{index: 2, scope: 'formList', query: 'comu_config_icmode'}]);
  },
  methods: {
    /* 永久多选框change */
    foreverChange (val) {
      this.formList.forEach((el) => {
        if (el.slot === 'expire') {
          if (val[0]) {
            el.subList[0].disabled = true;
            this.$refs.addEdit.form.setFieldsValue({ownerTime: 0});
            el.subList[0].props[1].rules.splice(1, 1);
          } else {
            el.subList[0].disabled = false;
            el.subList[0].props[1].rules[1] = { pattern: this.REG.positiveInt, message: '请输入正整数' };
          }
        }
      });
    },
    reqHandle (param) {
      for (let item in param) {
        param[item] === true && (param[item] = 1);
        param[item] === false && (param[item] = 0);
      }
      param.isForever = param.isForever.length ? param.isForever[0] : 0;
      return param;
    },
    detailResHandle (data) {
      let formValues = {};
      let keyArr = ['isFace', 'isPhoneAuth', 'isAutoAlloteKey', 'isOwnerAuth'];
      for (let item in data) {
        if (this.formKey.hasOwnProperty(item)) {
          formValues[item] = data[item];
          if (keyArr.some(el => el === item)) {
            data[item] === 1 ? formValues[item] = true : formValues[item] = false;
          }
        }
      }
      if (data.isForever === 1) {
        formValues.isForever = [data.isForever];
        this.formList.forEach((el) => {
          if (el.slot === 'expire') {
            el.subList[0].disabled = true;
          }
        });
      } else {
        formValues.isForever = [];
      }
      return formValues;
    }
  }
};
</script>

<style lang="scss">
/* 小区配置 */
.expire {
  margin-bottom: 0;
  .a-col {
    margin-right: 15px;
    .expire-item {
      .ant-form-item-label {
        display: inline-block;
        width: 60px;
      }
      .ant-form-item-control-wrapper {
        display: inline-block;
      }
    }
    .ant-input-number {
      width: 60px;
    }
    .ant-form-text {
      padding-right: 0;
    }
  }
  .a-col:first-child {
    margin-right: 5px;
  }
}
</style>
